import React, { useCallback, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useOutsideClick } from '../../hooks/useOutsideClick';
interface MultiSelectProps {
  options: string[];
  allLabel: string;
  selected: string[];
  onChange: (selected: string[]) => void;
  width?: number;
}
export function MultiSelect({
  options,
  allLabel,
  selected,
  onChange,
  width = 190
}: MultiSelectProps) {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const ref = useOutsideClick<HTMLDivElement>(close);
  const label = selected.length === 0 ? allLabel : selected.length === 1 ? selected[0] : `${selected.length} device types`;
  function toggle(option: string) {
    if (option === allLabel) {
      onChange([]);
      return;
    }
    onChange(selected.includes(option) ? selected.filter(s => s !== option) : [...selected, option]);
  }
  return <div ref={ref} className="relative" style={{
    width
  }} data-id="element-337" data-mp="3s87lvt7uesk2">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className={`flex h-9 w-full items-center justify-between gap-2 rounded-lg border bg-white px-3 text-left text-[13px] ${open ? 'border-brand-500' : 'border-ink-200'} text-ink-700 hover:bg-ink-50`} data-id="element-338" data-mp="14crd0x7kroze">
        <span className="truncate" data-id="element-339" data-mp="zcmvd3uxko7l">{label}</span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 text-ink-400 ${open ? 'rotate-180' : ''}`} data-id="element-340" data-mp="1n420f4e3djmj" />
      </button>
      {open && <ul className="absolute left-0 top-10 z-30 max-h-72 w-full min-w-[210px] overflow-y-auto rounded-lg border border-brand-500 bg-white py-1 shadow-pop" data-id="element-341" data-mp="1s2v4y7bei0ak">
          {[allLabel, ...options].map(option => {
        const checked = option === allLabel ? selected.length === 0 : selected.includes(option);
        return <li key={option} data-id="element-342" data-mp="7njrhp6yhfvh">
                <label className="flex cursor-pointer items-center gap-2 px-3 py-2 text-[13px] text-ink-700 hover:bg-ink-50" data-id="element-343" data-mp="7nted3wpf6wy">
                  <input type="checkbox" checked={checked} onChange={() => toggle(option)} className="h-4 w-4 rounded border-ink-300 text-brand-600 focus:ring-brand-500" data-id="element-344" data-mp="29c7imwwhazd9" />
                  {option}
                </label>
              </li>;
      })}
        </ul>}
    </div>;
}